// extracted by mini-css-extract-plugin
export default {"modal":"ModalDownload_modal__Wx1Cj","title":"ModalDownload_title__0+CeN","link":"ModalDownload_link__u1vjF","image":"ModalDownload_image__-t4f3","links":"ModalDownload_links__QFMe9"};